

















import { Vue, Component, Prop } from "vue-property-decorator";
import CustomContainer from "@/components/Globals/CustomContainer.vue";
import CustomButton from '@/components/Globals/CustomButton.vue';

@Component({
  components: {
    CustomContainer,
    CustomButton
  }
})
export default class AddYourImageGallerySelect extends Vue {
  public categories = []

  get translations() {
    return this.$store.state.translations.data;
  }

  @Prop({default: false})
  disableButton!: Boolean;

  @Prop({required: true})
  textLabel!: string;

  @Prop({required: false})
  keyTranslation!: string;

  clicked() {
    this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
    this.$modal.show('addYourImageGallery');
  }
};
